module.exports = __webpack_public_path__ + "static/img/TR-Testmark_9000022841_EN_CMYK_with-QR-Code.4c99b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TR-Testmark_9000022841_EN_CMYK_with-QR-Code.png
// module id = T5Od
// module chunks = 1